import { render, staticRenderFns } from "./marketingConsentModal.vue?vue&type=template&id=46ef554c"
import script from "./marketingConsentModal.vue?vue&type=script&lang=js"
export * from "./marketingConsentModal.vue?vue&type=script&lang=js"
import style0 from "./marketingConsentModal.vue?vue&type=style&index=0&id=46ef554c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports